import { tw } from "@careinfo/tailwind";
import FormCheckbox from "../Reusable/CheckBox";
import TextAreaField from "../Reusable/TextAreaField";
import TextField from "../Reusable/TextField";

const Form = (props: any) => {
  const {
    control,
    register,
    errors,
    watch,
    setValue,
    getValues,
    clearErrors,
    setOpenUnitFormPopup,
    setOpenCategoryFormPopup,
  } = props;
  return (
    <div className={tw`grid grid-cols-2 gap-x-4`}>
      <TextField
        control={control}
        name={"name"}
        label={"Product Name"}
        placeholder="Enter Product Name"
      />
      <TextField
        control={control}
        name={"hs_code"}
        label={"HS Code"}
        placeholder="Enter HS Code"
      />
      <TextAreaField
        label="Product Desc."
        control={control}
        rows={5}
        name={"description"}
        placeholder="Write description here..."
      />
      <div className={tw`mt-10`}>
        <FormCheckbox
          name="is_taxable"
          label="Taxable"
          register={register}
          watch={watch}
          setValue={setValue}
        />
      </div>
    </div>
  );
};

export default Form;
